module.exports = __webpack_public_path__ + "6bf7263440f720a284fc99ecaf454759.svg";